<template>
  <v-container fluid>
    <v-row
    >
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="8"
        offset-lg="2">
        <v-card
          v-if="sickbayRecords.length > 0"
          class="mb-3">
          <v-card-title
            style="background-color: crimson;"
            class="white--text font-weight-bold text-uppercase subheading pb-0 pt-0">
            <v-row justify="center">
              Sickbay Entries
            </v-row>
          </v-card-title>
          <v-card-text class="pb-2 pt-2">
            <v-row
              justify="space-between"
              class="text-center">
              <v-col
                class="font-weight-bold"
                cols="3"
              >Date</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
              >Incident</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
              >Description</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
              >Treatment</v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-text
            v-for="(entry, index) in sickbayRecords"
            :key="index">
            <v-row
              justify="space-between"
              class="text-center caption">
              <v-col cols="3">{{ entry.logdate }}</v-col>
              <v-col cols="3">{{ entry.illness }}</v-col>
              <v-col cols="3">{{ entry.description }}</v-col>
              <v-col cols="3">{{ entry.treatment }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="sickbayRecords.length == 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          There are no sickbay entries recorded in {{ (new Date()).getFullYear() }}.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    sickbayRecords: []
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get pupil details
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/sickbayV2')
        .then(resp => {
          vm.sickbayRecords = resp.data.sickbay
          vm.$store.commit('loading', false)
        })
    })
  },
  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
